module.exports = __webpack_public_path__ + "5aa71f3eeb64606b5b3a226273b59a1d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/public/fonts/Work_Sans/WorkSans-Regular.woff
// module id = 1817
// module chunks = 1